import { EditorBridge, registerAskClaudeAction } from './editorBridge';
/**
 * What a backend's `attachEditor` does: starts the editor bridge on `host` and
 * adds the "Ask Claude" action beside each field. Core's arguments are
 * duck-typed; this package does not depend on core.
 */
export function attachEditorBridge(host, {
  editor,
  registerFieldAction
}, options) {
  const baseUrl = options.baseUrl || options.supabaseId && `https://${options.supabaseId}.supabase.co`;
  if (!options.enabled || !baseUrl || !options.siteId || !options.anonKey) return;
  host.editorBridgeInstance = new EditorBridge(editor, {
    baseUrl,
    anonKey: options.anonKey,
    siteId: options.siteId,
    getAccessToken: options.getAccessToken
  });
  host.editorBridgeInstance.start();
  registerAskClaudeAction(registerFieldAction, () => host.editorBridgeInstance, options.siteId);
}